import { Component, OnInit } from '@angular/core';
import { Conversation } from '../../services/conversation';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatList, MatListItem, MatListItemLine, MatListItemTitle, MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { map, startWith, switchMap } from 'rxjs/operators';
import { MatFormField, MatInput, MatInputModule, MatLabel } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { AuthService } from '../../services/auth';
import { PermissionDeniedDialogComponent } from '../permission-denied-dialog.component';
import { MatDialog } from '@angular/material/dialog';



@Component({
  selector: 'app-conversation-list',
  imports: [CommonModule,MatListModule,MatProgressSpinnerModule,   
    MatInputModule, FormsModule, MatLabel, MatFormField, MatInputModule, MatInput, ReactiveFormsModule, MatListItem,
    MatListItemLine, MatIcon, MatList, MatListItemTitle, MatFormField, MatFormFieldModule,MatDatepickerModule,MatNativeDateModule,
    MatCard, MatCardContent
  ],
  templateUrl: './conversation-list.html',
  styleUrl: './conversation-list.scss',
  standalone: true
})
export class ConversationList implements OnInit {
  conversations$!: Observable<any[]>;
  filteredConversations$!: Observable<any[]>;
  searchControl = new FormControl('');
  searchTerm = '';

  endDate = new Date();
  startDate = new Date();
  user;
    

  constructor(
    private conversationService: Conversation,
    private router: Router,
    private authService: AuthService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.startDate.setDate(this.endDate.getDate() - 87);
    // console.log(, )
    let start = this.startDate.getTime();
    let end = this.endDate.getTime()
    this.conversations$ = this.conversationService.getConversations(undefined, undefined, start, end);
 
    this.filteredConversations$ = this.searchControl.valueChanges.pipe(
      startWith(''),
      switchMap(searchTerm => searchTerm ? this.filterConversations(searchTerm) : this.conversations$)
    );

     this.authService.user$.subscribe(user=>{
    if(user){
      this.user = user;
    }
   })
  }

  // Placeholder for clicking a conversation (used in next step)
 async onConversationClick(conversationId: string) {
    // this.router.navigate(['/conversation', conversationId]);
  const tokenResult = await this.user.getIdTokenResult();
    const allowView = tokenResult.claims.view_convos === true||tokenResult.claims.admin === true;
    // console.log(tokenResult)
      if (!allowView) {
        // Show modal
        const dialogRef = this.dialog.open(PermissionDeniedDialogComponent, {
          width: '400px',
          disableClose: true, // Prevent escape/click-out
          autoFocus: true
        });

        // Wait for user to click OK
        await dialogRef.afterClosed().toPromise();

      } else {
          this.router.navigate(['/conversation', conversationId]);
      }
    
  }

  onDateRangeChange(): void {
    console.log(this.startDate)
  if (!this.startDate || !this.endDate) return;

  const startMillis = this.startDate.getTime();
  const endMillis = this.endDate.getTime();

  console.log('Start (ms):', startMillis);
  console.log('End (ms):', endMillis);

  // Call your analytics function here, e.g., refresh data
  this.conversations$ = this.conversationService.getConversations(undefined, undefined, startMillis, endMillis);
  this.filteredConversations$ = this.searchControl.valueChanges.pipe(
      startWith(''),
      switchMap(searchTerm => searchTerm ? this.filterConversations(searchTerm) : this.conversations$)
    );
}

  filterConversations(searchTerm: string): Observable<any[]> {
    console.log(searchTerm)
    return this.conversations$.pipe(
      map(conversations => conversations.filter(conversation =>
        conversation.id.toLowerCase().includes(searchTerm.toLowerCase()) 
      ))
    );
  }

  async onFilterChange(){
    console.log(this.searchTerm)
    await this.filterConversations(this.searchTerm)
  }

}

